import { Box, CircularProgress } from "@mui/material";

const Loading = () => (
  <Box display="flex" alignItems="center" justifyContent="center" minHeight="300px" width="100%">
    <CircularProgress />
  </Box>
);

export default Loading;
